import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
const ANON = { status: "anon", role: null, ack: false };

export function AuthProvider({ children }) {
  const [state, setState] = useState({ status: "loading", role: null, ack: false });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setState({ status: "authed", ...data });
    } catch {
      setState(ANON);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const id = api.interceptors.response.use(
      (r) => r,
      (err) => {
        const url = err.config?.url || "";
        if (err.response?.status === 401 && !url.includes("/auth/")) {
          setState(ANON);
          toast.error("Your session has ended. Please sign in again.");
        }
        return Promise.reject(err);
      }
    );
    return () => {
      api.interceptors.response.eject(id);
    };
  }, []);

  const login = async (password) => {
    const { data } = await api.post("/auth/login", { password });
    setState({ status: "authed", ...data });
  };
  const acknowledge = async () => {
    const { data } = await api.post("/auth/acknowledge");
    setState({ status: "authed", ...data });
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } finally { setState(ANON); }
  };

  return <AuthCtx.Provider value={{ ...state, login, acknowledge, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
